import React from 'react';
import { useHistory } from 'react-router-dom';

import MessageCloneForm from 'components/formulas/MessageCloneForm';
import BasicModal from 'components/modals/basicModal';
import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';
import routes from '../../constants/routes';

import useGetLocationState from 'hooks/helper/useGetLocationState';

import {
    FormulaCloneOptions,
    FormulaDetailModel,
    FormulaSchedulingOptions,
} from 'models/formula.model';
import { TimingSlotsModel } from 'models/timing-slots.model';

import TestFormulaModalContext from 'views/formulaCreate/formulaEditor/assistant/testFormula/TestFormulaModalContext';
import MessageTimingConstraints from 'views/formulaCreate/formulaSettings/MessageTimingConstraints';
import FormulaEditModal from 'views/formulaView/FormulaEditModal';

interface FormulasCatalogModalsProps {
    activeFormula: FormulaDetailModel | null;
    cloningFormulaId: number | null;
    clearCloningFormulaId: () => void;
    submitClone: (values: { options: FormulaCloneOptions[] }) => void;
    isClonePending: boolean;
    isTestMessageClick: boolean;
    handleTestMessageClose: () => void;
    isEditModalOpen: boolean;
    closeEditModalHandler: () => void;
    showTimeSlotsModal: boolean;
    closeTimeSlotsModal: () => void;
    editLiveMessageHandler: () => void;
    timingSlots: TimingSlotsModel[] | undefined;
    schedulingType: FormulaSchedulingOptions;
}
export const FormulasCatalogModals: React.FC<
    React.PropsWithChildren<FormulasCatalogModalsProps>
> = ({
    activeFormula,
    cloningFormulaId,
    clearCloningFormulaId,
    submitClone,
    isClonePending,
    isTestMessageClick,
    handleTestMessageClose,
    isEditModalOpen,
    closeEditModalHandler,
    editLiveMessageHandler,
    showTimeSlotsModal,
    closeTimeSlotsModal,
    timingSlots,
    schedulingType,
}) => {
    const { getLocationState } = useGetLocationState('All Messages');
    const history = useHistory();
    const locationState = getLocationState();

    return (
        <>
            {cloningFormulaId && (
                <BasicModal width={'450px'} className="drawer-click-exempt">
                    <MessageCloneForm
                        onSubmit={submitClone}
                        onCancel={clearCloningFormulaId}
                        isSubmitting={isClonePending}
                    />
                </BasicModal>
            )}
            {isTestMessageClick && activeFormula && (
                <TestFormulaModalContext
                    handleClose={() => handleTestMessageClose()}
                    activeFormula={activeFormula}
                    className="drawer-click-exempt"
                />
            )}
            {isEditModalOpen && (
                <FormulaEditModal
                    onClose={closeEditModalHandler}
                    onEditLiveMessage={() => {
                        editLiveMessageHandler();
                        activeFormula &&
                            history.push(
                                routes.formulaView(
                                    activeFormula.active_state,
                                    activeFormula.id,
                                ),
                            );
                    }}
                    onEditMetadata={() => {
                        closeEditModalHandler();
                        const updatedState = {
                            ...locationState,
                            startEditing: true,
                        };
                        activeFormula &&
                            history.push(
                                routes.formulaView(
                                    activeFormula.active_state,
                                    activeFormula.id,
                                ),
                                updatedState,
                            );
                    }}
                    formulaFromProps={activeFormula}
                    className="drawer-click-exempt"
                />
            )}

            {showTimeSlotsModal && (
                <BasicModal
                    header="Time range"
                    width="500px"
                    handleClose={closeTimeSlotsModal}
                    headerStyle={{
                        justifyContent: 'space-between',
                        display: 'flex',
                        padding: aampeTheme.spacing4(4),
                    }}
                    className="drawer-click-exempt"
                >
                    <CalenderContainer className="drawer-click-exempt">
                        {timingSlots?.length && (
                            <MessageTimingConstraints
                                timingSlots={timingSlots}
                                formula={activeFormula!}
                                isDisabled={true}
                                schedulingType={schedulingType}
                            />
                        )}
                    </CalenderContainer>
                </BasicModal>
            )}
        </>
    );
};

const CalenderContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(2),
});
